import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Workspace from "./pages/Workspace";
import Login from "./pages/Login";
import PricingPage from "./pages/PricingPage";
import Settings from "./pages/Settings";
import VerifyEmail from "./pages/VerifyEmail";
import InvitePage from "./pages/InvitePage";
import AuthCallback from "./pages/AuthCallback";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import LegalPage from "./legal/LegalPage";
import CookieBanner from "./legal/CookieBanner";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import AdminSetup from "./pages/AdminSetup";
import Help from "./pages/Help";
import UserGuide from "./pages/UserGuide";
import PublicHelpButton from "./components/PublicHelpButton";
import SandboxBanner from "./components/SandboxBanner";
import SignOutButton from "./components/SignOutButton";
import { useAuth } from "./context/AuthContext";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.includes("#")) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Handle OAuth callback: detect session_id in URL fragment during render
export function AppRouter() {
  const location = useLocation();
  const { user } = useAuth();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <PublicHelpButton />
      {user ? <SignOutButton /> : null}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/workspace" element={<Workspace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/invite" element={<InvitePage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/setup" element={<AdminSetup />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/help" element={<UserGuide />} />
        <Route path="/support" element={<Help />} />
        <Route path="/privacy" element={<LegalPage docKey="privacy" />} />
        <Route path="/terms" element={<LegalPage docKey="terms" />} />
        <Route path="/cookies" element={<LegalPage docKey="cookies" />} />
        <Route path="/refund" element={<LegalPage docKey="refund" />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SandboxBanner />
        <AuthProvider>
          <AppRouter />
          <CookieBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
